import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

import ChildrenOrOutlet from "components/ChildrenOrOutlet";


export function ScrollToAnchorLayout({ children }: { children?: ReactNode }) {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    requestAnimationFrame(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
    });
  }, [ hash ]);

  return <ChildrenOrOutlet children={ children } />;
}
